import reducer from './reducers';
import * as types from './types';
import Environment from './Router';

export default Environment;
export { reducer, types };
